<template>
	<div class="stats-card">
		<div class="stats-icon" :class="`icon-${iconType}`">
			<i :class="iconClass"></i>
		</div>

		<div>
			<p class="stats-text">{{ title }}</p>
			<span>{{ value }}</span>
		</div>

		<hr class="separator" />

		<div class="stats-footer"><i :class="footerIcon"></i> {{ footerText }}</div>
	</div>
</template>

<script>
export default {
	props: [
		"iconClass",
		"iconType",
		"title",
		"value",
		"footerIcon",
		"footerText",
	],
};
</script>

<style scoped>
.stats-card {
	padding: 12px;
	border-radius: 8px;
	background-color: #fcfcfc;
	border: 0.5px solid #e8e9eb;
}

.stats-icon {
	margin-bottom: 10px;
}

.stats-text {
	color: black;
	text-transform: uppercase;
	font-size: 10px;
	font-weight: bolder;
	letter-spacing: 0.8px;
}

.separator {
	border-color: #dcdcdc;
}

.stats-footer {
	font-size: 10px;
	color: #989898;
}
</style>
